var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","strokeLinecap":"round","key":0},[React.createElement("path",{"d":"M.581 14.82L25.371.669l24.79 14.151v26.577l-24.79 13.92-24.79-13.92z","key":0}),React.createElement("path",{"fill":"#fff","d":"M25.37 2.972L2.582 15.982v24.244l22.79 12.797 22.79-12.797V15.981L25.37 2.971m0-2.302L50.16 14.82v26.577l-24.79 13.92L.58 41.397V14.82L25.371.669z","key":1})]),React.createElement("path",{"fill":"#fff","d":"M20.09 19.234v18.327l16.2-9.4z","key":1})]);
}

IconPlay.defaultProps = {"width":"50.741","height":"55.983","viewBox":"0 0 50.741 55.983"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
